import Grid from "components/Grid";
import Text from "components/Text";
import { FC } from "react";
import { CardTitleLeft } from "../PersonalInfo/PersonalInfo.styled";

export const CardTitle: FC<{
    icon: React.ReactNode;
    title: string;
}> = ({ title, icon }) => {
    return (
        <Grid row={true} justify="space-between" expanded>
            <CardTitleLeft>
                {icon}
                <Text variant="heading4" fontWeight="700" color="#434343">
                    {title}
                </Text>
            </CardTitleLeft>
        </Grid>
    );
};
